<template>
    <div class="address-summary">
        <span>{{address.fieldValues.firstName}} {{address.fieldValues.lastName}} <br></span>
        <span v-if="address.fieldValues.companyName">{{address.fieldValues.companyName}} <br></span>
        <span v-html="formatedAddress"/>
    </div>
</template>
<script src="./address-summary.js"/>
